import { Nullable } from 'types/global.types';
import { getFileExtensionFromPath, getFileNameFromPath } from 'utils/helpers';

type Config = {
  label: string;
  path: string;
  // --
  downloadName?: string;
  downloadNamePrefix?: string | Nullable<string>[];
  addFileTypeToFileLabel?: boolean;
  addFileTypeToDownloadName?: boolean;
  type?: string;
};

export const adaptDownLoadData = (config: Config) => {
  const type = config.type || getFileExtensionFromPath(config.path);
  const label = config.addFileTypeToFileLabel
    ? `${config.label}.${type}`
    : config.label;
  let downloadName = config.downloadName || getFileNameFromPath(config.path);
  if (config.addFileTypeToDownloadName) {
    downloadName = `${downloadName}.${type}`;
  }
  const downloadNamePrefixUniformed = Array.isArray(config.downloadNamePrefix)
    ? config.downloadNamePrefix.filter(Boolean).join('_')
    : config.downloadNamePrefix;
  const downloadNamePrefix = downloadNamePrefixUniformed
    ?.trim()
    .replace(/\s+/g, ' ');
  if (downloadNamePrefix) {
    downloadName = `${downloadNamePrefix}_${downloadName}`;
  }
  return {
    label,
    path: config.path,
    downloadName,
    type,
  };
};
